import React, { useState, useEffect } from 'react';
import './RecentPressCard.scss';
import { truncate } from '../../../../../util/truncate';
import { BREAKPOINTS } from '../../../../../constants/breakpoints';

const DESKTOP_WIDTH = BREAKPOINTS.large;

/**
 * Renders content for a recent press card type
 * @param {object} logo - the logo url and alt
 * @param {string} title - the card title/quote
 * @param {string} link - the link for the card
 * @param {string} date - the date for the card press
 * @param {string} excerpt - the excerpt for the card press article
 * @returns {JSX.Element}
 * @constructor
 */
const RecentPressCard = ({ logo, title, link, date, excerpt }) => {
  const [isDesktop, setIsDesktop] = useState(null);

  useEffect(() => {
    setIsDesktop(window.innerWidth > DESKTOP_WIDTH);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleResize = () => {
    setIsDesktop(window.innerWidth > DESKTOP_WIDTH);
  };

  // Mobile uses a different heading than desktop
  const TitleTag = isDesktop ? 'h4' : 'h3';

  return (
    <div className="c-recent-press-card">
      <div className="c-card__logo">
        <img src={logo.url} alt={logo.alt} />
      </div>
      <div className="c-recent-press-card__date eyebrow-2">
        <span>{date}</span>
      </div>
      <div className={`c-recent-press-card__title ${TitleTag}-roobert color-black`}>
        <TitleTag>{title}</TitleTag>
      </div>
      <div className="c-recent-press-card__excerpt body-2 color-black">
        <p>{truncate(excerpt)}</p>
      </div>
      <div className="c-recent-press-card__cta text-cta cta color-black">
        <a className="color-black" href={link} rel="noopener noreferrer" target="_blank">
          <span>Read More</span>
        </a>
      </div>
    </div>
  );
};

export default RecentPressCard;
